import { APP_BOOTSTRAP_LISTENER, NgModule } from '@angular/core';
import { UserRoutingModule } from './user-routing.module';
import { ConfigModule } from './config/config.module';
import { AuthStore } from 'features/user/store/auth.store';
import { UserApiService, UserAuthApiService } from 'features/user/api/api-tokens';
import { ApiFactoryFacade } from 'core/api/services/api-factory.facade';
import { Config } from 'core/config';
import { UserAuthService } from 'features/user/services/user-auth.service';
import { UserStore } from 'features/user/store/user.store';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { UserProfileInterceptor } from 'features/user/services/user-profile.interceptor';
import { UserIdleService } from 'features/user/services/user-idle.service';
import { ProfileEventModule } from 'features/user/user-events.module';

@NgModule({
  imports: [
    ConfigModule,
    UserRoutingModule,
    ProfileEventModule
  ],
  providers: [
    AuthStore,
    UserStore,
    {
      provide: UserApiService,
      useFactory: (apiFactory: ApiFactoryFacade, config: Config) => {
        return apiFactory.create(config.api!);
      },
      deps: [ ApiFactoryFacade, Config ]
    },
    {
      provide: UserAuthApiService,
      useFactory: (apiFactory: ApiFactoryFacade, config: Config) => {
        return apiFactory.create(config.apiAuth!);
      },
      deps: [ ApiFactoryFacade, Config ]
    },
    UserAuthService,
    UserIdleService,
    {
      provide: APP_BOOTSTRAP_LISTENER,
      useFactory: (idleService: UserIdleService) => {
        return () => {
          idleService.init();
        }
      },
      deps: [ UserIdleService ],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UserProfileInterceptor,
      multi: true,
    },
  ]
})
export class UserModule {
}
